import MfaCodeForm from "@/components/MfaCodeForm";
import { takeLoginNotice } from "@/lib/api";
import { GDPR_TEXT_VERSION } from "@/lib/gdpr";
import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";
import { PasswordInput } from "@/components/Layout";
import logo from "@/assets/HR.png";
import TileArt from "@/components/TileArt";
import { loadPlatformVersion } from "@/lib/version";

export default function LoginPurple() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [gdprConsent, setGdprConsent] = useState(false);
  const [version, setVersion] = useState("");
  useEffect(() => { loadPlatformVersion().then(setVersion); }, []);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [mfaToken, setMfaToken] = useState(null);   // al doilea pas (2FA)
  const [notice] = useState(() => takeLoginNotice());   // de ce am fost deconectat (parola s-a schimbat)

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (!gdprConsent) {
      setError("Trebuie să fii de acord cu prelucrarea datelor cu caracter personal (GDPR) pentru a continua.");
      return;
    }
    setLoading(true);
    try {
      const r = await login(username.trim().toLowerCase(), password, { gdprAccepted: gdprConsent });
      if (r?.mfa_required) setMfaToken(r); else nav("/");
    }
    catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Autentificare eșuată");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-art"><TileArt /></div>
      <div className="login-card">
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 22 }}>
          <img src={logo} alt="ONOMAD" style={{ height: 56, width: "auto" }} />
          <div style={{ fontWeight: 700, fontSize: 18, color: "#6B6B6B" }}>Platforma de HR</div>
        </div>
        {mfaToken ? <MfaCodeForm token={mfaToken.mfa_token} info={mfaToken} onDone={() => nav("/")} onBack={() => { setMfaToken(null); setPassword(""); }} /> : (
        <form onSubmit={submit} data-testid="login-form">
          {notice && <div style={{ background: "#FEF3C7", color: "#78350F", padding: "10px 14px", borderRadius: 8, marginBottom: 14, fontSize: 13 }} data-testid="login-notice">{notice}</div>}
          <h1>Autentificare</h1>
          <p style={{ color: "#6B6B6B", fontSize: 14, margin: "0 0 22px" }}>Introduceți datele de acces</p>
          <div style={{ marginBottom: 16 }}>
            <label className="label label-req">Utilizator</label>
            <input className="input" value={username} onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username" data-testid="login-username" />
          </div>
          <div style={{ marginBottom: 18 }}>
            <label className="label label-req">Parolă</label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" testId="login-password" />
          </div>
          <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 18 }}>
            <input type="checkbox" checked={gdprConsent} onChange={e => setGdprConsent(e.target.checked)} id="gdpr-consent" data-testid="login-gdpr-consent" style={{ marginTop: 3, accentColor: "var(--ac-500)" }} />
            <label htmlFor="gdpr-consent" style={{ fontSize: 12.5, color: "#555", lineHeight: 1.4, cursor: "pointer" }}>
              Sunt de acord cu prelucrarea datelor mele cu caracter personal în conformitate cu Regulamentul (UE) 2016/679 (GDPR), în scopul autentificării și utilizării platformei.
              <span style={{ display: "block", fontSize: 11, opacity: .7, marginTop: 2 }} data-testid="gdpr-version">Textul acordului, versiunea {GDPR_TEXT_VERSION}</span>
            </label>
          </div>
          {error && <div style={{ background: "#FCE8E6", color: "#B3261E", padding: "10px 14px", borderRadius: 10, marginBottom: 16, fontSize: 13 }} data-testid="login-error">{error}</div>}
          <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", padding: "12px 16px", fontSize: 15 }} disabled={loading} data-testid="login-submit">
            {loading ? "Se conectează..." : "Autentifică-te"}
          </button>
        </form>)}
        <div style={{ color: "#9A9A9A", fontSize: 11, marginTop: 20, textAlign: "center" }}>© {new Date().getFullYear()} ONOMAD - Platforma de HR{version && ` | Versiunea ${version}`}</div>
      </div>
    </div>
  );
}
